import { IconButton, iconButtonClasses, useMediaQuery, useTheme } from '@mui/material'
import { FC, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ThreadShortDTO } from '../../../../api/gen/base'
import DotsVerticalIcon from '../../../../assets/icons/DotsVertical.svg'
import InventoryIcon from '../../../../assets/icons/Inventory.svg?react'
import PenIcon from '../../../../assets/icons/Pen.svg?react'
import ShareIcon from '../../../../assets/icons/Share.svg?react'
import TrashIcon from '../../../../assets/icons/Trash.svg?react'
import { REQUEST_ROUTE } from '../../../../constants/routing.constants'
import { RequestArchiveDialog } from '../../../../dialogs/RequestArchiveDialog'
import { RequestDeteleDialog } from '../../../../dialogs/RequestDeteleDialog'
import { ShareDialog } from '../../../../dialogs/ShareDialog/ShareDialog'
import { RequestRenameDialog } from '../../../../pages/InternalPage/RequestsPage/dialog/RequestRenameDialog'
import { useDialogStore } from '../../../../store/storeDialog'
import { NavigationButton } from './NavigationButton'
import { SidebarMenu } from './SidebarMenu'

type Props = {
    request: ThreadShortDTO
}

export const RequestNavigationButton: FC<Props> = ({ request }) => {
    const { breakpoints } = useTheme()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const isMobile = useMediaQuery(breakpoints.down('sm'))

    const { updateThread } = useDialogStore()

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false)
    const [openRenameDialog, setOpenRenameDialog] = useState<boolean>(false)
    const [openShareDialog, setOpenShareDialog] = useState<boolean>(false)
    const [openArchiveDialog, setOpenArchiveDialog] = useState<boolean>(false)

    const requestsRouteWithId = `${REQUEST_ROUTE}/${request.id}`

    const handleOpenRequest = () => {
        navigate(`${requestsRouteWithId}?is_archived=false`)
    }

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()

        setAnchorEl(event.currentTarget)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const handleCloseAll = () => {
        setOpenRemoveDialog(false)
        setOpenRenameDialog(false)
        setOpenShareDialog(false)
        setOpenArchiveDialog(false)
        setAnchorEl(null)
    }

    const handleClickOpenRemoveDialog = () => {
        setOpenRemoveDialog(true)
    }

    const handleClickOpenRequestRenameDialog = () => {
        setOpenRenameDialog(true)
    }

    const handleClickOpenShareDialog = () => {
        setOpenShareDialog(true)
    }

    const handleClickCloseShareDialog = () => {
        setOpenShareDialog(false)
    }

    const handleClickOpenArchiveDialog = () => {
        setOpenArchiveDialog(true)
    }

    const handleCopy = () => {
        if (request.shared) {
            return
        }

        updateThread({ threadId: request.id }, { shared: true })
    }

    const open = Boolean(anchorEl)

    return (
        <>
            <RequestDeteleDialog
                open={openRemoveDialog}
                handleClose={handleCloseAll}
                id={request.id}
            />
            <RequestRenameDialog
                request={request}
                open={openRenameDialog}
                handleClose={handleCloseAll}
            />
            <ShareDialog
                open={openShareDialog}
                onClose={handleClickCloseShareDialog}
                entityId={request.id}
                entityName="thread"
                onCopy={handleCopy}
            />
            <RequestArchiveDialog
                open={openArchiveDialog}
                handleClose={handleCloseAll}
                theadDetail={request}
            />
            <SidebarMenu
                verticalPosition="top"
                anchorEl={anchorEl}
                menuItems={[
                    {
                        key: '1',
                        label: 'Переименовать',
                        onClick: handleClickOpenRequestRenameDialog,
                        icon: <PenIcon color="#5F6675" width={24} height={24} />,
                    },
                    {
                        key: '2',
                        label: 'Архивировать',
                        onClick: handleClickOpenArchiveDialog,
                        icon: <InventoryIcon color="#5F6675" width={24} height={24} />,
                    },
                    {
                        key: '3',
                        label: 'Поделиться',
                        onClick: handleClickOpenShareDialog,
                        icon: <ShareIcon color="#5F6675" width={24} height={24} />,
                    },
                    {
                        key: '4',
                        label: 'Удалить',
                        onClick: handleClickOpenRemoveDialog,
                        icon: <TrashIcon color="#E82C1F" width={24} height={24} />,
                        color: '#E82C1F',
                    },
                ]}
                onClose={handleCloseMenu}
            />
            <NavigationButton
                onClick={handleOpenRequest}
                endIcon={
                    <IconButton onClick={handleOpenMenu}>
                        <DotsVerticalIcon />
                    </IconButton>
                }
                isActive={pathname.includes(requestsRouteWithId)}
                sx={{
                    [`.${iconButtonClasses.root}`]: {
                        visibility: open || isMobile ? 'visible' : 'hidden',
                    },
                    ':hover': {
                        [`.${iconButtonClasses.root}`]: {
                            visibility: 'visible',
                        },
                    },
                }}>
                {request.name}
            </NavigationButton>
        </>
    )
}
